import { createContext, useContext } from 'react';

/**
 * MockAuthProvider - Simulates Clerk authentication for UI testing
 * 
 * IMPORTANT: This is ONLY for UI Harness mode (/__ui-harness/*)
 * Does NOT bypass real authentication
 * Does NOT connect to real APIs
 */

const MockAuthContext = createContext(null);

// Export hook with Clerk's name for compatibility
export function useAuth() {
  return useContext(MockAuthContext);
}

export function MockAuthProvider({ children }) {
  // Mock Clerk user object
  const mockUser = {
    id: 'mock_user_123',
    emailAddresses: [{ emailAddress: 'test@example.com' }],
    firstName: 'Test',
    lastName: 'User',
    fullName: 'Test User',
  };

  // Mock auth functions
  const getToken = async () => 'mock_jwt_token_for_ui_testing';
  const signOut = () => console.log('[UI Harness] Mock sign out');

  const value = {
    isLoaded: true,
    isSignedIn: true,
    user: mockUser,
    getToken,
    signOut,
  };

  return (
    <MockAuthContext.Provider value={value}>
      {children}
    </MockAuthContext.Provider>
  );
}
